import React, { PureComponent, ReactNode } from 'react'
import { Application } from '../../config'
import { appsPrivacyAndTermsOptionsSelected } from '../../helpers/app'
import { LiteralsService } from '../../services'

const { isAmb } = Application

/**
 * The legal paragraph — who treats the data, with links to the privacy policy and the terms —
 * as the app shows it on the last sign up step and the terms screen. The host wraps it in
 * whatever box it needs; links open in a new tab.
 */
export default class TermsAndConditionsText extends PureComponent {
  public render(): ReactNode {
    return isAmb ? this.ambContent : this.defaultContent
  }

  private get ambContent(): ReactNode {
    return (
      <>
        { LiteralsService.get('ambTermsAndConditionsText') }
        { ' ' + LiteralsService.get('and') + ' ' + LiteralsService.get('termsLinkArticle') }
        <span className="link" onClick={ goToTerms }>{ LiteralsService.get('ambLinkTermsAndConditions') }.</span>
      </>
    )
  }

  private get defaultContent(): ReactNode {
    const owner = appsPrivacyAndTermsOptionsSelected?.owner || ''
    return (
      <>
        { LiteralsService.get('termsAndConditionsText').replace('{0}', owner) }
        <span className="link" onClick={ goToPrivacyPolicy }>{ LiteralsService.get('linkPrivacyPolicy') }</span>
        { ' ' + LiteralsService.get('and') + ' ' + LiteralsService.get('termsLinkArticle') }
        <span className="link" onClick={ goToTerms }>{ LiteralsService.get('linkTermsAndConditions') }.</span>
      </>
    )
  }
}

// Brands with one document per language get the current one appended to the URL.
export function privacyUrl(): string {
  const options = appsPrivacyAndTermsOptionsSelected!
  return options.someLanguages ? options.privacy + LiteralsService.getLanguage() : options.privacy
}

export function termsUrl(): string {
  const options = appsPrivacyAndTermsOptionsSelected!
  return options.someLanguages ? options.terms + LiteralsService.getLanguage() : options.terms
}

function goToPrivacyPolicy(): void {
  window.open(privacyUrl(), '_blank')
}

function goToTerms(): void {
  window.open(termsUrl(), '_blank')
}
